import { render, staticRenderFns } from "./ModalEditContato.vue?vue&type=template&id=c12fddd4&"
import script from "./ModalEditContato.vue?vue&type=script&lang=js&"
export * from "./ModalEditContato.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditContato.vue?vue&type=style&index=0&id=c12fddd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports